import { render, staticRenderFns } from "./UploadModuleExamButton.vue?vue&type=template&id=1f4a7767"
import script from "./UploadModuleExamButton.vue?vue&type=script&lang=js"
export * from "./UploadModuleExamButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports